export { default } from './text'
